import { useState, useEffect, useCallback } from 'react';
import { api, MarketplaceEntity } from '../../lib/api';

interface UseFeaturedEntitiesReturn {
  entities: MarketplaceEntity[];
  loading: boolean;
  error: string | null;
  refresh: () => void;
}

export function useFeaturedEntities(limit: number = 12): UseFeaturedEntitiesReturn {
  const [entities, setEntities] = useState<MarketplaceEntity[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchFeatured = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const result = await api.getFeaturedEntities(limit);
      setEntities(result.entities);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load featured entities');
      setEntities([]);
    } finally {
      setLoading(false);
    }
  }, [limit]);

  useEffect(() => {
    fetchFeatured();
  }, [fetchFeatured]);

  return {
    entities,
    loading,
    error,
    refresh: fetchFeatured,
  };
}
